import { ApiProperty } from "@nestjs/swagger";

export class AttendanceMonthRequest {
    @ApiProperty()
    year: number;
    @ApiProperty()
    month: number;
    @ApiProperty()
    departmentId?: number;
    @ApiProperty()
    shift?: string;
    @ApiProperty()
    unitId?: number;
    @ApiProperty()
    category?: string;

    /**
     * @param year
     * @param month 
     * @param departmentId 
     * @param shift 
     * @param unitId 
     */
    constructor(year:number,month: number, departmentId?: number, shift?: string, unitId?: number,
        category?: string
    ) {
        this.year = year
        this.month = month;
        this.departmentId = departmentId;
        this.shift = shift;
        this.unitId = unitId;
        this.category=category
    }
}